import { parseParams } from '../../../common';
import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { isStructureColumnType } from '../../types/helpers';
export const createColumnStmtInstruction = `
#### Add column

- Syntax: \`add column <column_name> as <column_type> in <view_name>.<scope_name>[ with <plugin_params>];\`
- Example: \`add column name as text in ProductList.ProductList;\` (to add a name field or column, now referred to as an element, in a product list view).
- Example: \`add column category.name as text in ProductList.ProductList;\` (Use \`.property_name\` when accessing specific attributes within a related entity is required.)
- Example: \`add column tags as select in ProductList.ProductList;\` (Here, the focus is on adding the relationship element itself, without detailing properties within the related entity.)

#### Alter column type

- Syntax: \`alter column <field_name> as <new_field_type> in <form_name>[ with <plugin_params>];\`
- Example: \`alter column name as string in ProductFrom;\` (to add a name field or column, now referred to as an element, in a product list view).
- Example: \`alter column category.name as string in ProductForm;\` (Use \`.property_name\` when accessing specific attributes within a related entity is required.)
- Example: \`alter column tags as select in ProductForm;\` (Here, the focus is on adding the relationship element itself, without detailing properties within the related entity.)
`;
export const stmtAddStructureColumn = ({ columnName, columnType, viewName, scopeName, pluginParams, }) => {
    const formatParams = pluginParams ? ` with ${pluginParams}` : '';
    if (!columnType) {
        return `add column ${columnName} in ${viewName}.${scopeName}${formatParams};`;
    }
    return `add column ${columnName} as ${columnType} in ${viewName}.${scopeName}${formatParams};`;
};
export const createColumnHandler = createStructureStatementHandler({
    type: 'add column',
    parse: line => {
        const match = /^(add|alter) column (?<columnName>[\w.]+)( as (?<columnType>\w+))? in (?<viewName>\w+)\.(?<scopeName>\w+)(?: with (?<pluginParams>[^;]+))?/.exec(line);
        return match?.groups
            ? {
                type: 'add column',
                columnName: match.groups.columnName,
                scopeName: match.groups.scopeName,
                viewName: match.groups.viewName,
                columnType: isStructureColumnType(match.groups.columnType) ? match.groups.columnType : undefined,
                pluginParams: parseParams(match.groups.pluginParams),
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.addColumn({
                viewName: stmt.viewName,
                scopeName: stmt.scopeName,
                columnName: stmt.columnName,
                columnType: stmt.columnType,
                pluginParams: stmt.pluginParams,
            });
        });
    },
});
//# sourceMappingURL=CreateColumnStmt.js.map